import { useContext } from 'react'
import { EndowmentContext } from '@/contexts'

export const useEndowment = () => useContext(EndowmentContext)
